<script lang="ts">
  import { formatNumber } from '$lib/utils/numberFormat';

  interface Props {
    value: number;
    digitsInfo?: string;
    locale?: string;
  }

  let { value, digitsInfo = '1.0-3', locale = 'en-US' }: Props = $props();

  let formattedValue = $derived(formatNumber(value, { digitsInfo, locale }));
</script>

{formattedValue}
